// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import t from 'app/utils/translate';
import Button from 'app/components/commons/Button';
import Icon from 'app/components/commons/Icon';
import LightTab from 'app/components/commons/LightTab';
import LightTabSet from 'app/components/commons/LightTabSet';
import MenuWrapper from 'app/components/commons/MenuWrapper';
import Responsive from 'app/components/responsive/Responsive';
import { joinUntilFalsy } from 'app/utils/stringUtils';

type Props = {
  activeSport?: string,
  onShowBatchEdit: () => void,
  onShowUpload: () => void,
  section: string,
  uploadLineup?: boolean
};

const defaultProps = {
  activeSport: undefined,
  uploadLineup: false
};

const Tabs = styled(LightTabSet)(
  {
    display: 'flex',
    paddingTop: 2
  },
  ({ theme }) => ({
    marginBottom: theme.spacing.default
  })
);

const UploadIcon = styled(Icon)(({ theme }) => ({
  fontSize: '1.2em',
  marginLeft: theme.spacing.xsmall
}));

const Wrapper = styled('div')({
  display: 'flex'
});

function MyTeamsMenu({ activeSport, uploadLineup, onShowBatchEdit, onShowUpload, section }: Props) {
  return (
    <Wrapper>
      <MenuWrapper component={Tabs} value={section}>
        <LightTab id="live-teams" to={joinUntilFalsy(['/my-teams/live-teams', activeSport], '/')}>
          {t('Live Teams')}
        </LightTab>
        <LightTab
          id="upcoming-teams"
          to={joinUntilFalsy(['/my-teams/upcoming-teams', activeSport], '/')}
        >
          {t('Upcoming Teams')}
        </LightTab>
        <LightTab
          id="swap-players"
          to={joinUntilFalsy(['/my-teams/swap-players', activeSport], '/')}
        >
          {t('Swap')}
        </LightTab>
      </MenuWrapper>
      {uploadLineup && (
        <Responsive desktop>
          <Button autoBorderRadius={false} kind="success" onClick={onShowUpload}>
            <div className="buttonInner">
              <span>Upload</span>
              <UploadIcon type="icon-cloud-upload" />
            </div>
          </Button>
          <Button autoBorderRadius={false} kind="secondary" onClick={onShowBatchEdit}>
            <div className="buttonInner">
              <span style={{ whiteSpace: 'nowrap' }}>Batch Edit</span>
              <UploadIcon type="icon-edit" />
            </div>
          </Button>
        </Responsive>
      )}
    </Wrapper>
  );
}

MyTeamsMenu.defaultProps = defaultProps;

export default MyTeamsMenu;
